import './CustomerFeedbackPopup.css';
import { tVelocityRecord } from './VelocityReport';
import { tTeamMember } from '../data/Team';

interface DeveloperDetailsPopupProps {
  developer: tTeamMember;
  velocityHistory: tVelocityRecord[];
  closeDeveloperDetailsCallback: () => void;
  dismissEmployeeCallback: (developerId: number) => void;
  sprintInProgress: boolean;
}

// Helper function to get job title (same logic as TeamMemberCard)
function getJobTitleForSkillLevel(skillLevel: number): string {
  enum eJobTitle {
    Trainee = 0.25,
    JuniorDeveloper = 0.5,
    JuniorSoftwareDeveloper = 0.75,
    Developer = 1,
    SoftwareEngineer = 1.25,
    SeniorSoftwareDeveloper = 1.5,
    LeadDeveloper = 1.75  
  }

  if (skillLevel >= eJobTitle.Trainee && skillLevel < eJobTitle.JuniorDeveloper) {
    return "Trainee";
  } else if (skillLevel >= eJobTitle.JuniorDeveloper && skillLevel < eJobTitle.JuniorSoftwareDeveloper) {
    return "Junior Developer";
  } else if (skillLevel >= eJobTitle.JuniorSoftwareDeveloper && skillLevel < eJobTitle.Developer) {
    return "Junior Software Developer";
  } else if (skillLevel === eJobTitle.Developer) {
    return "Developer";
  } else if (skillLevel > eJobTitle.Developer && skillLevel <= eJobTitle.SoftwareEngineer) {
    return "Software Engineer";
  } else if (skillLevel > eJobTitle.SoftwareEngineer && skillLevel <= eJobTitle.SeniorSoftwareDeveloper) {
    return "Senior Software Developer";
  } else if (skillLevel > eJobTitle.SeniorSoftwareDeveloper && skillLevel <= eJobTitle.LeadDeveloper) {
    return "Lead Developer";
  } else {
    return "Unknown Skill Level";
  }
}

export default function DeveloperDetailsPopup(props: DeveloperDetailsPopupProps) {
  const jobTitle = getJobTitleForSkillLevel(props.developer.level);
  
  return (
    <div className="popup-overlay">
      <div className={`customer-feedback-popup-modal`}>
        <h3>👤 Developer Details</h3>
        
        {/* Employee file section */}
        <div style={{ marginBottom: '20px', padding: '15px', backgroundColor: '#f9f9f9', borderRadius: '5px' }}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <span style={{ fontSize: '48px', marginRight: '15px' }}>{props.developer.icon}</span>
            <div>
              <h2 style={{ margin: '0 0 5px 0' }}>{props.developer.name}</h2>
              <p style={{ margin: '0', fontWeight: 'bold', color: '#666' }}>{jobTitle}</p>
            </div>
          </div>
          <div style={{ marginTop: '10px' }}>
            <p style={{ margin: '5px 0' }}><strong>Specialty:</strong> {props.developer.skill}</p>
            <p style={{ margin: '5px 0' }}><strong>Description:</strong> {props.developer.description}</p>
          </div>
        </div>
        
        {/* Sprint performance table */}
        <h4 style={{ marginTop: '20px', marginBottom: '10px' }}>Sprint Performance</h4>
        <table className="feedback-table">
          <thead>
            <tr>
              <th>Sprint</th>
              <th>Dev Story Points</th>
              <th>QA Story Points</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            {props.velocityHistory.length === 0 ? (
              <tr>
                <td colSpan={4} style={{ textAlign: 'center', fontStyle: 'italic', color: '#666' }}>
                  No sprint data available yet
                </td>
              </tr>
            ) : (
              props.velocityHistory.map((record) => {
                const devData = record.developerVelocity[props.developer.id];
                const devPoints = devData?.code || 0;
                const qaPoints = devData?.qa || 0;
                const total = devPoints + qaPoints;
                
                return (
                  <tr key={record.sprint}>
                    <td>{record.sprint}</td>
                    <td style={{ textAlign: 'right' }}>{devPoints}</td>
                    <td style={{ textAlign: 'right' }}>{qaPoints}</td>
                    <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{total}</td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
        
        <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
          <button 
            className="close-button" 
            style={{ 
              backgroundColor: '#dc3545',
              flex: 1
            }}
            onClick={() => props.dismissEmployeeCallback(props.developer.id)}
            disabled={props.sprintInProgress}
            onMouseEnter={(e) => {
              if (!props.sprintInProgress) {
                e.currentTarget.style.backgroundColor = '#c82333';
              }
            }}
            onMouseLeave={(e) => {
              if (!props.sprintInProgress) {
                e.currentTarget.style.backgroundColor = '#dc3545';
              }
            }}
          >
            {props.sprintInProgress ? '🚫 Cannot Dismiss (Sprint Active)' : '❌ Dismiss Employee'}
          </button>
          <button 
            className="close-button" 
            style={{ flex: 1 }}
            onClick={props.closeDeveloperDetailsCallback}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
